<div class="multi-select">
  <div (click)="toggleExpand()" class="select-bar">
    @if (!selectedFilters?.length) {
      <span class="select-placeholder">
        {{ 'multiSearch.filterByStatus' | translate }}
        @if (form.get('selected_type')?.value === searchTypes.WORK_ORDER) {
          <span>
            {{ 'multiSearch.byWorkOrder' | translate }}
          </span>
        }
        @if (form.get('selected_type')?.value === searchTypes.INVERTER) {
          <span>
            {{ 'multiSearch.byInverter' | translate }}
          </span>
        }
        @if (form.get('selected_type')?.value === searchTypes.TYPE3) {
          <span>
            {{ 'multiSearch.byType3WorkOrder' | translate }}
          </span>
        }
        @if (form.get('selected_type')?.value === searchTypes.POWERLINE) {
          <span>
            {{ 'multiSearch.byPowerline' | translate }}
          </span>
        }
      </span>
    } @else {
      <span class="select-placeholder">
        @for (status of selectedFilters; track $index) {
          <span class="status-color"
            [style.color]="status.color">
            ⬤
          </span>
        }
        <span class="ms-3">{{ selectedFilters?.length }} {{ 'multiSearch.selected' | translate }}</span>
      </span>
    }
    @if (expanded) {
      <img class="caret" src="assets/icons/expand_less_gray_24dp.svg">
    }
    @if (!expanded) {
      <img class="caret" src="assets/icons/expand_more_gray_24dp.svg">
    }
  </div>

  @if (expanded) {
    <div class="row multi-select-search">
      @if (form) {
        <form [formGroup]="form">
          <!-- SELECT ALL -->
          <dl class="row filter-row" (click)="onSelectAllRowClick($event)">
            <dt class="col-1">
              <label class="custom-checkbox-label">
                <input
                  class="filter-checkbox"
                  type="checkbox"
                  formControlName="select_all"
                  (click)="$event.stopPropagation()"
                  (change)="selectAll()"
                  />
                <span class="custom-checkbox"></span>
              </label>
            </dt>
            <dd class="col-11 row-text">
              {{ 'multiSearch.showAll' | translate }}
              <span class="result-count">
                ({{ getWorkOrderCount(form.get('selected_type')?.value) }})
              </span>
            </dd>
          </dl>
          <!-- TYPE SELECTION -->
          @if (showTypes) {
            @if (!showTypesToggle) {
              <dl (click)="toggleType()" class="row filter-row">
                <dt class="col-1">
                  <img src="assets/icons/expand_more_gray_24dp.svg">
                </dt>
                <dd class="col-11 row-text">
                  @if (!getSelectedType()) {
                    <span>{{ 'multiSearch.selectType' | translate }}</span>
                  }
                  @if (getSelectedType(); as type) {
                    <span>
                      {{ 'multiSearch.type' | translate }}: {{ ('multiSearch.type' + type) | translate }}
                    </span>
                  }
                </dd>
              </dl>
            } @else {
              <dl (click)="toggleType()" class="row filter-row">
                <dt class="col-1">
                  <img src="assets/icons/expand_less_gray_24dp.svg">
                </dt>
                <dd class="col-11 row-text">
                  {{ 'multiSearch.closeTypeSelection' | translate }}
                </dd>
              </dl>
              @if (filtersExist(searchTypes.WORK_ORDER)) {
                <dl class="row filter-row type">
                  <dt class="col-1">
                    <label class="custom-checkbox-label">
                      <input class="filter-checkbox"
                        type="checkbox"
                        [checked]="form.get('selected_type')?.value === searchTypes.WORK_ORDER"
                        (change)="setSearchType(searchTypes.WORK_ORDER)">
                      <span class="custom-checkbox"></span>
                    </label>
                  </dt>
                  <dd class="col-11 row-text">
                    {{ 'basic.workorder' | translate }}
                  </dd>
                </dl>
              }
              @if (filtersExist(searchTypes.INVERTER)) {
                <dl class="row filter-row type">
                  <dt class="col-1">
                    <label class="custom-checkbox-label">
                      <input class="filter-checkbox"
                        type="checkbox"
                        [checked]="form.get('selected_type')?.value === searchTypes.INVERTER"
                        (change)="setSearchType(searchTypes.INVERTER)">
                      <span class="custom-checkbox"></span>
                    </label>
                  </dt>
                  <dd class="col-11 row-text">
                    {{ 'multiSearch.inverter' | translate }}
                  </dd>
                </dl>
              }
              @if (filtersExist(searchTypes.TYPE3)) {
                <dl class="row filter-row type">
                  <dt class="col-1">
                    <label class="custom-checkbox-label">
                      <input class="filter-checkbox"
                        type="checkbox"
                        [checked]="form.get('selected_type')?.value === searchTypes.TYPE3"
                        (change)="setSearchType(searchTypes.TYPE3)">
                      <span class="custom-checkbox"></span>
                    </label>
                  </dt>
                  <dd class="col-11 row-text">
                    {{ 'multiSearch.type3WorkOrder' | translate }}
                  </dd>
                </dl>
              }
              @if (filtersExist(searchTypes.POWERLINE)) {
                <dl class="row filter-row type">
                  <dt class="col-1">
                    <label class="custom-checkbox-label">
                      <input class="filter-checkbox"
                        type="checkbox"
                        [checked]="form.get('selected_type')?.value === searchTypes.POWERLINE"
                        (change)="setSearchType(searchTypes.POWERLINE)">
                      <span class="custom-checkbox"></span>
                    </label>
                  </dt>
                  <dd class="col-11 row-text">
                    {{ 'multiSearch.powerline' | translate }}
                  </dd>
                </dl>
              }
            }
          }
          <!-- TYPES -->
          <div>
            <!-- MODE SELECTION -->
            @if (showModes) {
              @if (!showModesToggle) {
                <dl (click)="toggleMode()" class="row filter-row">
                  <dt class="col-1">
                    <img src="assets/icons/expand_more_gray_24dp.svg">
                  </dt>
                  <dd class="col-11 row-text">
                    @if (!getSelectedMode()) {
                      <span>{{ 'multiSearch.selectMode' | translate }}</span>
                    }
                    @if (getSelectedMode(); as mode) {
                      <span>
                        {{ 'multiSearch.mode' | translate }}: {{ ('multiSearch.' + mode) | translate }}
                      </span>
                    }
                  </dd>
                </dl>
              } @else {
                <dl (click)="toggleMode()" class="row filter-row">
                  <dt class="col-1">
                    <img src="assets/icons/expand_less_gray_24dp.svg">
                  </dt>
                  <dd class="col-11 row-text">
                    {{ 'multiSearch.closeModeSelection' | translate }}
                  </dd>
                </dl>
                <!-- REPORTED CURRENT -->
                @if (allowedModes.includes(searchModes.REPORTED_CURRENT)) {
                  <dl
                    class="row filter-row mode">
                    <dt class="col-1">
                      <label class="custom-checkbox-label">
                        <input class="filter-checkbox"
                          type="checkbox"
                          [formControlName]="searchModes.REPORTED_CURRENT"
                          (change)="setFilterMode(searchModes.REPORTED_CURRENT, true)">
                        <span class="custom-checkbox"></span>
                      </label>
                    </dt>
                    <dd (click)="toggleSelectedMode(searchModes.REPORTED_CURRENT)"
                      class="col-11 row-text">
                      {{ 'multiSearch.reported_current' | translate }}
                    </dd>
                  </dl>
                }
                <!-- REPORTED CURRENT NOT -->
                @if (allowedModes.includes(searchModes.REPORTED_CURRENT_NOT)) {
                  <dl
                    class="row filter-row mode">
                    <dt class="col-1">
                      <label class="custom-checkbox-label">
                        <input class="filter-checkbox"
                          type="checkbox"
                          [formControlName]="searchModes.REPORTED_CURRENT_NOT"
                          (change)="setFilterMode(searchModes.REPORTED_CURRENT_NOT, true)">
                        <span class="custom-checkbox"></span>
                      </label>
                    </dt>
                    <dd (click)="toggleSelectedMode(searchModes.REPORTED_CURRENT_NOT)"
                      class="col-11 row-text">
                      {{ 'multiSearch.reported_current_not' | translate }}
                    </dd>
                  </dl>
                }
                <!-- REPORTED ANY -->
                <dl class="row filter-row mode" (click)="selectMode(searchModes.REPORTED_ANY)">
                  <dt class="col-1">
                    <label class="custom-checkbox-label">
                      <input
                        class="filter-checkbox"
                        type="checkbox"
                        [formControlName]="searchModes.REPORTED_ANY"
                        (click)="$event.stopPropagation()"
                        (change)="selectMode(searchModes.REPORTED_ANY)"
                        />
                      <span class="custom-checkbox"></span>
                    </label>
                  </dt>
                  <dd class="col-11 row-text">{{ 'multiSearch.reported_any' | translate }}</dd>
                </dl>
                <!-- REPORTED ANY NOT -->
                <dl class="row filter-row mode" (click)="selectMode(searchModes.REPORTED_ANY_NOT)">
                  <dt class="col-1">
                    <label class="custom-checkbox-label">
                      <input
                        class="filter-checkbox"
                        type="checkbox"
                        [formControlName]="searchModes.REPORTED_ANY_NOT"
                        (click)="$event.stopPropagation()"
                        (change)="selectMode(searchModes.REPORTED_ANY_NOT)"
                        />
                      <span class="custom-checkbox"></span>
                    </label>
                  </dt>
                  <dd class="col-11 row-text">{{ 'multiSearch.reported_any_not' | translate }}</dd>
                </dl>
              }
            }
            <!-- MODES -->
            <!-- SEARCH COUNT -->
            <ng-template #searchCount>
              <div class="search-count">
                @if (form.get('select_all')?.value) {
                  {{ 'Results' | translate }}: {{ getWorkOrderCount(form.get('selected_type')?.value) }}
                } @else {
                  {{ 'Results' | translate }}: {{ workOrdersFiltered?.length }}
                }
              </div>
            </ng-template>
            <!-- FILTERS NOT EXIST -->
            <ng-template #noFiltersAvailable>
              <div class="no-filters-available">
                <span class="badge bg-warning">{{ 'multiSearch.noFiltersAvailable' | translate }}</span>
              </div>
            </ng-template>
            <!-- FILTERS -->
            @if (!isPowerlines()) {
              <ng-container formGroupName="filters">
                @if (filtersExist(form.get('selected_type')?.value)) {
                  <ng-container
                    [formGroupName]="form.get('selected_type')?.value">
                    @for (filter of formFilters; track $index) {
                      <dl class="row filter-row"
                        [ngClass]="{ 'selected': getFilter(form.get('selected_type')?.value, filter.status)?.value }">
                        <dt class="col-1">
                          <label class="custom-checkbox-label">
                            <input class="filter-checkbox"
                              type="checkbox"
                              [formControlName]="filter.status"
                              (change)="filterChanged()">
                            <span class="custom-checkbox"></span>
                          </label>
                        </dt>
                        <dd class="col-11 row-text" (click)="toggleFilter(filter.status)">
                          @if (getFilterStatus(filter.status); as status) {
                            <span class="status-color"
                              [style.color]="status?.color">
                              ⬤
                            </span>
                            <span class="filter-definition">{{ status?.id }}. {{ status?.definition }}</span>
                            <span class="result-count">
                              ({{ getWorkOrderCount(form.get('selected_type')?.value, status?.state) }})
                            </span>
                          }
                        </dd>
                      </dl>
                    }
                    <ng-container *ngTemplateOutlet="searchCount"></ng-container>
                  </ng-container>
                } @else {
                  <div class="no-filters-available">
                    <span class="badge bg-warning">{{ 'multiSearch.noFiltersAvailable' | translate }}</span>
                  </div>
                }
              </ng-container>
            } @else {
              <ng-container formGroupName="filters">
                @if (!filtersExist(searchTypes.POWERLINE)) {
                  <ng-container *ngTemplateOutlet="noFiltersAvailable"></ng-container>
                }
                @for (filter of formFilters; track $index) {
                  <!-- TITLE -->
                  @if (filter.title) {
                    <dl class="row filter-row title">
                      <dt class="col-11">
                        {{ 'multiSearch.' + filter.title | translate }}
                      </dt>
                      <dd class="col-1 row-text">
                      </dd>
                    </dl>
                  }
                  <!-- INPUT -->
                  <ng-container [formGroupName]="filter.type">
                    <dl class="row filter-row"
                      [ngClass]="{ 'selected': getFilter(filter.type, filter.status)?.value }">
                      <dt class="col-1">
                        <label class="custom-checkbox-label">
                          <input class="filter-checkbox"
                            type="checkbox"
                            [formControlName]="filter.status"
                            (change)="filterChanged()">
                          <span class="custom-checkbox"></span>
                        </label>
                      </dt>
                      <dd class="col-11 row-text" (click)="toggleFilter(filter.status, filter.type)">
                        @if (getFilterStatus(filter.status); as status) {
                          <span class="status-color"
                            [style.color]="status?.color">
                            ⬤
                          </span>
                          <span class="filter-definition">{{ status?.id }}. {{ status?.definition }}</span>
                          <span class="result-count">
                          ({{ getWorkOrderCount(filter.type, status?.state) }})</span>
                        }
                      </dd>
                    </dl>
                  </ng-container>
                }
                <ng-container *ngTemplateOutlet="searchCount"></ng-container>
              </ng-container>
            }
            <!-- POWERLINE FILTERS -->
          </div>
        </form>
      }
    </div>
  }
</div>
